import { startOfToday, startOfDay, format, isValid, parse, parseISO } from "date-fns";

export const DEFAULT_DATE_FORMAT = "dd-MM-yyyy";
const ISO_DATE_OR_DATE_TIME_PATTERN = /^\d{4}-\d{2}-\d{2}(T.*)?$/;

export function jsonToJsDate(jsonDate: Date): Date | null {
  return dateEmpty(jsonDate)
    ? null // else you get as date-time 01-01-1970T00:00:00z
    : new Date(jsonDate);
}

export function dateEmpty(inputDate: Date): boolean {
  return !inputDate || inputDate.toString() === "";
}

export function dateInFuture(inputDate: Date): boolean {
  return dateEmpty(inputDate) || inputDate > startOfToday();
}

export function formatDate(
  inputDate: Date,
  d_format = DEFAULT_DATE_FORMAT
): string | null {
  return inputDate && isValid(inputDate) ? format(inputDate, d_format) : null;
}

export function parseDateExact(
  inputDate: string,
  d_format = DEFAULT_DATE_FORMAT
): Date | null {
  if (!inputDate) return null;

  const value = inputDate.trim();
  const parsed = parse(value, d_format, new Date());
  return isValid(parsed) && format(parsed, d_format) === value
    ? parsed
    : null;
}

export function toDayFormatted(d_format = "yyyy-MM-dd"): string {
  return format(startOfToday(), d_format);
}

export function nowFormatted(
  df_format = "yyyy-MM-dd_HH.mm.ss"
): string {
  return format(new Date(), df_format);
}

export function tryParseIsoDateValue(input: unknown): Date | null {
  if (typeof input !== "string") return null;

  const value = input.trim();
  if (!value || !ISO_DATE_OR_DATE_TIME_PATTERN.test(value)) return null;

  const parsed = parseISO(value);
  return isValid(parsed) ? normalizeDateForDateFilter(parsed) : null;
}

export function normalizeDateForDateFilter(input: Date): Date {
  return startOfDay(input);
}
